import Loader from '../../components/Loader/Loader';
import { ReactNode, useEffect, useState } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

interface ClientPrincipal {
  userId: string;
  userDetails: string;
  identityProvider: string;
  userRoles: string[];
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    fetch('/.auth/me')
      .then((res) => res.json())
      .then((data: { clientPrincipal?: ClientPrincipal }) => {
        if (data.clientPrincipal) {
          setAuthenticated(true);
        } else {
          window.location.href = '/.auth/login/add';
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return authenticated ? <>{children}</> : null;
}
